//dependencias
import React, { Component } from 'react';

//componentes
import InformeAde from './informeAde'

class Index extends Component {

    render(){
        return(
            <div>
                <InformeAde />
            </div>
        );
    }

}
export default Index;